import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check/admin`;
const LABELS = { Bill: 'T-Bill', Note: 'T-Note', Bond: 'T-Bond' };
const sel = 'w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm focus:border-emerald-500 outline-none';

export const ReopeningPicker = ({ token, busy, disabled, onRegister }) => {
  const [data, setData] = useState(null);
  const [type, setType] = useState('Bond');
  const [key, setKey] = useState('');
  useEffect(() => {
    axios.get(`${API}/reopenings`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setData(r.data.reopenings)).catch(() => setData({}));
  }, [token]);
  const rows = data?.[type] || [];
  useEffect(() => { setKey(rows[0] ? `${rows[0].cusip}|${rows[0].auction_date}` : ''); }, [type, data]);
  const chosen = rows.find(r => `${r.cusip}|${r.auction_date}` === key);
  return (
    <div className="mt-4 pt-4 border-t border-slate-700" data-testid="tc-reopening-picker">
      <p className="text-xs uppercase tracking-wide text-slate-500 mb-2">Acquire under a reopening CUSIP</p>
      {!data ? <p className="text-xs text-slate-500">Loading reopenings...</p> : (<>
        <div className="grid grid-cols-3 gap-2">
          <select value={type} onChange={(e) => setType(e.target.value)} data-testid="tc-reopening-type" className={sel}>
            {Object.entries(LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <select value={key} onChange={(e) => setKey(e.target.value)} data-testid="tc-reopening-cusip" className={`${sel} col-span-2`}>
            {rows.map(r => <option key={`${r.cusip}|${r.auction_date}`} value={`${r.cusip}|${r.auction_date}`}>{r.cusip} · {r.security_term} · auction {r.auction_date}</option>)}
            {!rows.length && <option value="">No recent reopenings</option>}
          </select>
        </div>
        {chosen && <p className="text-xs text-slate-400 mt-2" data-testid="tc-reopening-details">Maturity {chosen.maturity_date} · coupon {chosen.coupon_pct}% · yield {chosen.high_yield_pct}% · price {chosen.price_per_100} · ref hash {chosen.reference_hash.slice(0, 14)}…</p>}
        <button onClick={() => chosen && onRegister({ security_type: type, cusip: chosen.cusip, auction_date: chosen.auction_date })} disabled={busy || disabled || !chosen}
          data-testid="tc-register-selected-btn" className="mt-3 px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm disabled:opacity-40">Make selected CUSIP active on-chain</button>
      </>)}
    </div>
  );
};
